/* tslint:disable */
import {
  Library,
  Screen,
  Tag
} from '../index';

declare var Object: any;
export interface AudioInterface {
  "id": string;
  "FilenameOnServer": string;
  "OriginalFilename": string;
  "Description"?: string;
  "AudioFormat": string;
  "RunTime": number;
  "FileSize": number;
  "ThumbnameFilename": string;
  "Metadata"?: any;
  "Categories"?: string;
  "Container"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId"?: string;
  library?: Library;
  screens?: Screen[];
  tags?: Tag[];
}

export class Audio implements AudioInterface {
  "id": string;
  "FilenameOnServer": string;
  "OriginalFilename": string;
  "Description": string;
  "AudioFormat": string;
  "RunTime": number;
  "FileSize": number;
  "ThumbnameFilename": string;
  "Metadata": any;
  "Categories": string;
  "Container": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "libraryId": string;
  library: Library;
  screens: Screen[];
  tags: Tag[];
  constructor(data?: AudioInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Audio`.
   */
  public static getModelName() {
    return "Audio";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Audio for dynamic purposes.
  **/
  public static factory(data: AudioInterface): Audio{
    return new Audio(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Audio',
      plural: 'Audios',
      path: 'Audios',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "FilenameOnServer": {
          name: 'FilenameOnServer',
          type: 'string'
        },
        "OriginalFilename": {
          name: 'OriginalFilename',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "AudioFormat": {
          name: 'AudioFormat',
          type: 'string'
        },
        "RunTime": {
          name: 'RunTime',
          type: 'number'
        },
        "FileSize": {
          name: 'FileSize',
          type: 'number'
        },
        "ThumbnameFilename": {
          name: 'ThumbnameFilename',
          type: 'string'
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "Container": {
          name: 'Container',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
      },
      relations: {
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'ScreenAudio',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'audioId'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagAudio',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'audioId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Audio.ts